import { useFormContext } from 'react-hook-form';

import type { FieldEventContext, SectionKey } from '../lease-details.types';

export const useFieldEventContextBuilder = <TValue>(
  path: string,
  sectionKey: SectionKey,
  arrayIndex?: number,
) => {
  const { getFieldState, formState, getValues } = useFormContext();
  return (value: TValue, optionId?: string): FieldEventContext<TValue> => ({
    value,
    valid: !getFieldState(path, formState).invalid,
    fieldPath: path,
    arrayIndex,
    sectionKey,
    optionId,
    getValues: (name?: string) => (name == null ? getValues() : getValues(name)),
  });
};
